import { createSelector } from '@reduxjs/toolkit';

import { Direction2D } from '@paragon/geometry-library';
import { findAndCalculateLine } from '@paragon/relative-geometry';

import { getActiveComponent } from './getActiveComponentSelector';

export const getFlatTopChordGuids = createSelector(getActiveComponent, (component) => {
  if (!component) return [];

  return component.members
    .filter(
      ({ memberType, relativeGeometry }) =>
        memberType === 'TopChord' &&
        findAndCalculateLine(relativeGeometry?.lineGuid ?? null, component)?.direction.isParallelTo(Direction2D.left),
    )
    .map(({ guid }) => guid);
});
